import { render, staticRenderFns } from "./SolanStudentViewJournalsT.vue?vue&type=template&id=7b12a514&scoped=true&"
import script from "./SolanStudentViewJournalsT.vue?vue&type=script&lang=ts&"
export * from "./SolanStudentViewJournalsT.vue?vue&type=script&lang=ts&"
import style0 from "./SolanStudentViewJournalsT.vue?vue&type=style&index=0&id=7b12a514&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b12a514",
  null
  
)

export default component.exports